import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import Typography from '../../../../components/Typography/Typography'
import SnackCard from './components/SnackCard/SnackCard'

import { useEffect } from 'react'
import './AddSnackCoupon.scss'
import ReservationInfo from './components/NoReservation/ReservationInfo'

import hocAddSnackCoupon from './hocAddSnackCoupon'

const AddSnackCoupon = ({ snacksListOffer, loadSnacks, snacksInBasket, ticketsLength }) => {
    const intl = useIntl()

    const haveSnack = snacksInBasket && snacksInBasket?.length > 0

    useEffect(() => {
        loadSnacks()
    }, [ticketsLength])

    return (
        <Container fluid className="add-snack-coupon d-flex flex-column">
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'yourOrder.addSnackCoupon' })}</Typography>
            <Container fluid className="add-snack-coupon--cards d-flex">
                {Array.isArray(snacksListOffer) &&
                    snacksListOffer?.map((item, idx) => {
                        return (
                            <SnackCard
                                key={idx}
                                title={item?.name}
                                description={item?.note}
                                price={item?.price}
                                voucherid={item.voucherid}
                                cardAmount={snacksInBasket?.find((snack) => snack.voucherid === item.voucherid)?.amount}
                            />
                        )
                    })}
            </Container>

            <ReservationInfo display={haveSnack} />
        </Container>
    )
}

export default hocAddSnackCoupon(AddSnackCoupon)
